<template>
    <div>
        <div class="container text-left">
            <div class="page-head">
                <div>
                    <h4>
                        Use the following form only if your organization is a
                        member.
                    </h4>
                </div>
                <a class="light-blue" href="/"
                    >Click here to check other membership options</a
                >
                <div><h4 class="heading">Create Account</h4></div>
                <div>
                    Already registered?
                    <a
                        class="green"
                        href="https://financialdataexchange.org/FDX/Contact_Management/Sign_In.aspx?LoginRedirect=true&returnurl=%2fFDX%2fContact-Us.aspx"
                        >Sign In</a
                    >
                </div>
            </div>
            <div class="box">
                <form>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label
                                    for="Prefix"
                                    class="col-sm-4 col-form-label"
                                    >Prefix</label
                                >
                                <div class="col-sm-7">
                                    <select
                                        class="form-control"
                                        id="Prefix"
                                        v-model="prefix"
                                    >
                                        <option>(None)</option>
                                        <option>Dr.</option>
                                        <option>Miss</option>
                                        <option>Mr.</option>
                                        <option>Mrs.</option>
                                        <option>Ms.</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label
                                    for="inputFirst"
                                    class="col-sm-4 col-form-label required"
                                    >First name</label
                                >
                                <div class="col-sm-7">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="fname"
                                        id="inputFirst"
                                    />
                                    <span class="valMsg" id="inputFirstVal" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label
                                    for="inputMiddle"
                                    class="col-sm-4 col-form-label"
                                    >Middle name</label
                                >
                                <div class="col-sm-7">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="mname"
                                        id="inputMiddle"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label
                                    for="inputLast"
                                    class="col-sm-4 col-form-label required"
                                    >Last name</label
                                >
                                <div class="col-sm-7">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="lname"
                                        id="inputLast"
                                    />
                                    <span class="valMsg" id="inputLastVal" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label
                                    for="Suffix"
                                    class="col-sm-4 col-form-label"
                                    >Suffix</label
                                >
                                <div class="col-sm-7">
                                    <select
                                        class="form-control"
                                        id="Suffix"
                                        v-model="suffix"
                                    >
                                        <option>(None)</option>
                                        <option>II</option>
                                        <option>III</option>
                                        <option>IV</option>
                                        <option>Jr.</option>
                                        <option>Sr.</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label
                                    for="inputTitle"
                                    class="col-sm-4 col-form-label required"
                                    >Organization Title</label
                                >
                                <div class="col-sm-7">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="orgTitle"
                                        id="inputTitle"
                                    />
                                    <span class="valMsg" id="inputTitleVal" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label
                                    for="inputOrgname"
                                    class="col-sm-4 col-form-label required"
                                    >Organization</label
                                >
                                <div class="col-sm-7">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="orgName"
                                        id="inputOrgname"
                                        @input="searchOrg"
                                        @blur="checkOrgExists()"
                                        :disabled="emailVerified"
                                    />
                                    <div
                                        v-show="orgList && showOrgList"
                                        class="dropdown-list"
                                    >
                                            <li
                                                @click="selectedOrg(item)"
                                                v-for="item in orgList"
                                                :key="item.imisId"
                                                class="dropdown-item"
                                            >
                                                {{ item.name }}
                                            </li>
                                    </div>
                                    <span class="valMsg" id="inputOrgnameVal" />
                                    <span
                                        id="org_already_exists"
                                        style="display: none"
                                        v-show="otherOrg == true"
                                    >
                                        <span
                                            class="verifyli pl-3"
                                            style="color: #fe3a31"
                                        >
                                            <em
                                                class="
                                                    fas
                                                    fa-exclamation-circle
                                                "
                                                style="color: red"
                                            ></em>
                                            Organization Does Not Exist</span
                                        >
                                        <a
                                            type="button"
                                            class="errormsg pl-3"
                                            style="color: #1fa785"
                                            @click="
                                                $router.push({
                                                    name: 'Get Started',
                                                    query: {
                                                        prefix: prefix,
                                                        firstName: fname,
                                                        middleName: mname,
                                                        lastName: lname,
                                                        suffix: suffix,
                                                        title: orgTitle,
                                                    },
                                                })
                                            "
                                            >Please select other participation
                                            options</a
                                        >
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row business-email ">
                                <label
                                    for="inputOrgemail"
                                    class="col-sm-4 col-xs-4 col-form-label required"
                                    >Business Email</label
                                >
                                <div class="col-sm-7">
                                    <input
                                        type="text"
                                        class="form-control col-sm-5 col-xs-5"
                                        id="inputOrgemail"
                                        v-model="userName"
                                        @blur="isEmailValid()"
                                        :disabled="emailVerified"
                                    />
                                    <div
                                        class="form-control col-sm-2 col-xs-2 business-email-col-2"
                                        style="
                                            font-size: 16px;
                                            border: 0px;
                                            box-shadow: 0px 0px 0px;
                                        "
                                    >
                                        @
                                    </div>
                                    <select
                                        class="form-control col-sm-5 col-xs-5"
                                        id="inputOrgemailDomain"
                                        v-model="orgDomainName"
                                        @blur="isEmailValid()"
                                        :disabled="emailVerified"
                                    >
                                        <option
                                            v-for="domain in orgDomains"
                                            :value="domain"
                                            v-bind:key="domain.id"
                                        >
                                            {{ domain }}
                                        </option>
                                    </select>
                                    <div
                                        style="
                                            font-size: 12px;
                                            font-style: italic;
                                        "
                                    >
                                        <em
                                            class="fas fa-info-circle blue"
                                        ></em>
                                        Domain not listed? Please contact
                                        <a
                                            style="color: #1fa785"
                                            href="https://financialdataexchange.org/FDX/Contact-Us.aspx"
                                            >FDX Support</a
                                        >
                                    </div>
                                    <img
                                        v-show="emailStatus === 'LOADING'"
                                        class="apiLoader"
                                        src="../assets/loading.png"
                                        alt="LOADING"
                                    />
                                    <a v-show="emailStatus === 'ERROR'">
                                        <span
                                            class="valMsg"
                                            id="inputOrgemailVal"
                                        />
                                    </a>
                                    <!-- <a
                                        type="button"
                                        id="verify-email"
                                        class="errormsg"
                                        v-show="emailStatus === 'VERIFY'"
                                        @click="sendEmail"
                                    >
                                        <em
                                            class="
                                                fas
                                                fa-exclamation-circle
                                                orange
                                            "
                                        ></em>
                                        Verify Email</a
                                    > -->
                                    <span
                                        class="verifyli pl-3 green"
                                        style="display: none"
                                        v-show="this.emailVerified"
                                        id="valid_email_msg"
                                    >
                                        <em
                                            class="fas fa-check-circle green"
                                        ></em>
                                        Validated</span
                                    >
                                    <span
                                        id="invalid_email_msg"
                                        style="display: none"
                                        v-show="emailStatus === 'INVALID'"
                                    >
                                        <span
                                            class="verifyli pl-3"
                                            style="color: #fe3a31"
                                        >
                                            <em
                                                class="
                                                    fas
                                                    fa-exclamation-circle
                                                "
                                                style="color: red"
                                            ></em>
                                            Invalid Email</span
                                        >
                                        <a
                                            type="button"
                                            class="errormsg pl-3 green"
                                            @click="moreinfo"
                                            >More Info</a
                                        >
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label
                                    for="inputUser"
                                    class="col-sm-4 col-form-label"
                                    >Username</label
                                >
                                <div class="col-sm-7">
                                    <input
                                        type="text"
                                        disabled
                                        class="form-control"
                                        v-model="email"
                                        placeholder=""
                                        style="border: 1"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label
                                    for="inputPwd"
                                    class="col-sm-4 col-form-label required"
                                    >Password</label
                                >
                                <div class="col-sm-7">
                                    <input
                                        type="password"
                                        class="form-control"
                                        v-model="password"
                                        id="inputPwd"
                                    />
                                    <span class="valMsg" id="inputPwdVal" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label
                                    for="inputCpwd"
                                    class="col-sm-4 col-form-label required"
                                    >Confirm password</label
                                >
                                <div class="col-sm-7">
                                    <input
                                        type="password"
                                        class="form-control"
                                        v-model="cpassword"
                                        id="inputCpwd"
                                    />
                                    <span class="valMsg" id="inputCpwdVal" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div
                                class="card"
                                id="email_invalid"
                                style="display: none"
                            >
                                <h4>
                                    <strong>WHY WAS MY EMAIL INVALID?</strong>
                                </h4>
                                <p>
                                    FDX is comprised of member firms, companies,
                                    organizations and a limited number of
                                    industry leading individuals. In order to
                                    keep the FDX API, related artifacts and
                                    other documents confidential, FDX has a
                                    general policy of only distributing its
                                    materials to active businesses, firms,
                                    companies and other organizations with
                                    dedicated websites/emails (i.e., not to
                                    personal accounts such as Gmail, Yahoo,
                                    Hotmail, Yandex, etc.) with security
                                    protocols. We invite you to re-submit your
                                    request on behalf of your firm, company or
                                    other affiliated organization.
                                </p>
                                <br />
                                <p>
                                    If your circumstance requires special
                                    consideration, please contact FDX’s
                                    General Counsel at
                                    <span class="green"
                                        >FDXLegal@financialdataexchange.org</span
                                    >
                                    with a description of your circumstances and
                                    reason for a waiver of this general policy.
                                </p>
                                <br />
                                <p><strong>Thank you.</strong></p>
                            </div>
                        </div>
                    </div>
                    <p class="text-left" style="margin-left: 20px">
                        <em class="fas fa-info-circle blue"></em>
                        <em
                            >The password must be at least 8 characters long and
                            must contain at least 1 upper case, 1 lower case and
                            1 number. Special characters - *&%$#@!)( - are
                            allowed.</em
                        >
                    </p>
                    <div class="form-group row">
                        <div class="col-md-2 col-sm-2 col-xs-6  text-left">
                            <button
                                type="button"
                                id="exit1"
                                class="btn btn-default btn1 btn-block"
                                data-toggle="modal"
                                data-target="#myModal1"
                            >
                                EXIT
                            </button>
                        </div>
                        <div class="col-sm-offset-8 col-md-2 col-sm-2 col-xs-6 text-right">
                            <button
                                type="button"
                                class="btn btn-default btn1 btn-block"
                                @click="nextStep"
                                v-show="!this.emailVerified"
                            >
                                PROCEED
                            </button>
                            <button
                                type="button"
                                class="btn btn-default btn1 btn-block"
                                @click="nextStep"
                                v-show="this.emailVerified"
                            >
                                SAVE
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="myModal" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Please verify your email before proceeding
                        </h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            A verification link has been sent to your email
                            inbox.
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-default btn1"
                            data-dismiss="modal"
                            @click="closeTab()"
                        >
                            CONTINUE
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="myModal1" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Are you sure you want to exit?
                        </h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>All unsaved changes will be lost</p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-default btn1"
                            data-dismiss="modal"
                            @click="abandonUser"
                        >
                            YES
                        </button>
                        <button
                            type="button"
                            class="btn btn-default btn1"
                            data-dismiss="modal"
                        >
                            NO
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading === true">
            <loader
                object="#1c71d8"
                color1="#ffffff"
                color2="#17fd3d"
                size="5"
                speed="2"
                bg="#343a40"
                objectbg="#999793"
                opacity="80"
                disableScrolling="false"
                name="dots"
            ></loader>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Toast from "../common/Toast";

export default {
    name: "AccountViewOrganization",
    components: {},
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    created() {
        if (!(this.$route.query.from === 'startPage' || JSON.parse(this.$store.state.user))) {
            this.$router.push({name: "Get Started",});
        }
        if (this.$store.state.pageState === "WelcomeToFDX") {
            this.$router.push({
                name: "WelcomeToFDX",
            });
        }
        this.setUp();

        this.emailValidCheckMutation();

        this.unsubscribe = this.$store.subscribe((mutation) => {
            if (
                mutation.type === "createUserOrgResponse" &&
                mutation.payload !== null
            ) {
                if (
                    JSON.parse(this.$store.state.userOrgResponse).status ===
                    true
                ) {
                    this.$gtag.event("CreateUserOrg", {
                        event_category: "general",
                        event_label: "Created User and Organization",
                        email: JSON.parse(this.$store.state.user).email,
                        orgName: this.orgName.trim(),
                    });
                    JSON.parse(this.$store.state.user).membershipType =
                        this.membershipType;
                    this.$store.state.pageState = "WelcomeToFDX";
                    this.$router.push("/login");
                }
            }

            if (
                mutation.type === "setOrganizationList" &&
                mutation.payload !== null
            ) {
                this.orgList = JSON.parse(this.$store.state.organizationList);
            }

            if (
                mutation.type === "setDomainsByOrganization" &&
                mutation.payload !== null
            ) {
                this.orgDomains = JSON.parse(
                    this.$store.state.domainsByOrganization
                );
            }
        });
    },
    unmounted() {
        this.unsubscribe();
    },
    watch: {
        fname(val) {
            this.fname = val.replace(/[^A-Z.\-']/gi, "").substring(0, 64);
            document.getElementById("inputFirst").style.borderColor = "";
            document.getElementById("inputFirstVal").innerHTML = "";
        },
        mname(val) {
            this.mname = val.replace(/[^A-Z.\-' ]/gi, "").substring(0, 64);
        },
        lname(val) {
            this.lname = val.replace(/[^A-Z.\-']/gi, "").substring(0, 64);
            document.getElementById("inputLast").style.borderColor = "";
            document.getElementById("inputLastVal").innerHTML = "";
        },
        userName(val) {
            document.getElementById("inputOrgemail").style.borderColor = "";
            document.getElementById("inputOrgemailDomain").style.borderColor =
                "";
            document.getElementById("inputOrgemailVal").innerHTML = "";
            document.getElementById("email_invalid").style.display = "none";
            this.emailStatus = null;
            this.sameEmail = null;
            if (this.emailValid) {
                this.emailValid = null;
                this.$store.state.emailValid = null;
            }
            if (!this.emailVerified) {
                this.email = null;
            }
            this.userName = val.toLowerCase();
        },
        orgDomainName() {
            document.getElementById("inputOrgemailVal").innerHTML = "";
            document.getElementById("email_invalid").style.display = "none";
            document.getElementById("inputOrgemail").style.borderColor = "";
            document.getElementById("inputOrgemailDomain").style.borderColor =
                "";
            this.emailStatus = null;
            this.sameEmail = null;
            if (this.emailValid) {
                this.emailValid = null;
                this.$store.state.emailValid = null;
            }
        },
        password(val) {
            this.password = val.substring(0, 32);
            document.getElementById("inputPwd").style.borderColor = "";
            document.getElementById("inputPwdVal").innerHTML = "";
        },
        cpassword() {
            document.getElementById("inputCpwd").style.borderColor = "";
            document.getElementById("inputCpwdVal").innerHTML = "";
        },
        orgTitle(val) {
            this.orgTitle = val.replace(/[^A-Z.\-' ]/gi, "").substring(0, 64);
            document.getElementById("inputTitle").style.borderColor = "";
            document.getElementById("inputTitleVal").innerHTML = "";
        },
        orgName() {
            this.otherOrg = false;
            if (this.orgSelected !== this.orgName) {
                this.orgSelected = null;
                this.orgValidity = null;
                this.imisId = null;
                this.userName = null;
                this.orgDomainName = null;
                this.orgDomains = null;
                this.emailStatus = null;
                this.email = null;
                document.getElementById("inputOrgname").style.borderColor = "";
                document.getElementById("inputOrgnameVal").innerHTML = "";
            }
        },
    },
    data() {
        return {
            prefix: "",
            fname: "",
            mname: "",
            lname: "",
            suffix: "",
            orgTitle: "",
            email: "",
            phone: "",
            mobile: "",
            password: "",
            cpassword: "",
            orgName: "",
            showModal: false,
            pwdreg: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d*&%$#@!)(]{8,}$/, // /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{8,}$/,
            reg: /^[a-zA-Z\d_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z\d.-]+$/, //(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,24}))$/,
            isValid: false,
            tempMsg: "",
            emailValid: null,
            sameEmail: null,
            emailStatus: null,
            emailVerified: null,
            ofacValid: null,
            sameOrgName: null,
            orgValidity: null,
            orgList: null,
            showOrgList: false,
            orgSelected: false,
            userName: null,
            orgDomainName: null,
            orgDomains: null,
            imisId: null,
            orgRequestId: null,
            otherOrg: false,
            loading: false,
        };
    },
    methods: {
        ...mapActions([
            "checkEmailValid",
            "initiateVerifyEmail",
            "checkOfacValid",
            "getAbandonmentStatus",
            "initiateCreateUserOrg",
            "getOrganizationList",
            "getDomainsByOrganization",
        ]),

        setUp() {
            if (this.$route.query.firstName) {
                this.prefix = this.$route.query.prefix;
                this.fname = this.$route.query.firstName;
                this.mname = this.$route.query.middleName;
                this.lname = this.$route.query.lastName;
                this.suffix = this.$route.query.suffix;
                this.orgTitle = this.$route.query.title;
                this.$store.state.user = null;
            }

            if (JSON.parse(this.$store.state.user)) {
                this.membershipType = JSON.parse(
                    this.$store.state.user
                ).membershipType;
                this.prefix = JSON.parse(this.$store.state.user).prefix;
                this.fname = JSON.parse(this.$store.state.user).firstName;
                this.mname = JSON.parse(this.$store.state.user).middleName;
                this.lname = JSON.parse(this.$store.state.user).lastName;
                this.suffix = JSON.parse(this.$store.state.user).suffix;
                this.orgTitle = JSON.parse(this.$store.state.user).title;
                this.email = JSON.parse(this.$store.state.user).email;
                this.emailVerified = true;
                this.sameEmail = this.email;
                let emailArray = this.email.split("@");
                this.userName = emailArray[0];
                this.orgDomainName = emailArray[1];
                this.orgSelected = JSON.parse(
                    this.$store.state.user
                ).organizationRequest.name;
                this.orgName = JSON.parse(
                    this.$store.state.user
                ).organizationRequest.name;
                this.imisId = JSON.parse(
                    this.$store.state.user
                ).organizationRequest.imisId;
                this.orgRequestId = JSON.parse(
                    this.$store.state.user
                ).organizationRequest.organizationRequestId;
                this.password = window.atob(JSON.parse(this.$store.state.user).password);
                this.cpassword = this.password;
            }
        },

        emailValidCheckMutation() {
            this.unsubscribe = this.$store.subscribe((mutation) => {
                if (
                    mutation.type === "setEmailValid" &&
                    mutation.payload !== null
                ) {
                    if (JSON.parse(this.$store.state.emailValid)) {
                        this.emailValid = JSON.parse(
                            this.$store.state.emailValid
                        );
                        if (
                            this.emailValid.status === false &&
                            this.emailValid.userExists === true
                        ) {
                            document.getElementById(
                                "inputOrgemail"
                            ).style.borderColor = "#FE3A31";
                            document.getElementById(
                                "inputOrgemailDomain"
                            ).style.borderColor = "#FE3A31";
                            this.emailStatus = "ERROR";

                            if (this.emailValid.userActive === false) {
                                document.getElementById(
                                    "inputOrgemailVal"
                                ).innerHTML =
                                    "There is an issue with this email address. Please contact<a class='errormsg pl-3' style='color: #1fa785' href='" + "https://financialdataexchange.org/" + "FDX/Contact-Us.aspx' >FDX Support.</a >";
                                Toast.showToast(
                                    "There is an issue with this email address. Please contact FDX Support",
                                    "E"
                                );
                            } else {
                                document.getElementById(
                                    "inputOrgemailVal"
                                ).innerHTML =
                                    "This email address already exists.<a class='errormsg pl-3' style='color: #1fa785' href='/login' >Please sign in</a >";
                                Toast.showToast(
                                    "This email address already exists. Please sign in",
                                    "E"
                                );
                            }
                            this.emailVerified = false;
                        } else {
                            this.isEmailValid();
                        }
                    }
                }
            });
        },

        nextStep() {
            const red = "#FE3A31";
            if (!this.fname) {
                Toast.showToast("First Name is Required", "E");
                document.getElementById("inputFirst").style.borderColor = red;
                document.getElementById("inputFirst").scrollIntoView(true);
                document.getElementById("inputFirstVal").innerHTML =
                    "First Name is Required";
                return;
            }
            if (!this.lname) {
                Toast.showToast("Last Name is Required", "E");
                document.getElementById("inputLast").style.borderColor = red;
                document.getElementById("inputLast").scrollIntoView(true);
                document.getElementById("inputLastVal").innerHTML =
                    "Last Name is Required";
                return;
            }
            if (!this.orgTitle) {
                Toast.showToast("Organization Title is Required", "E");
                document.getElementById("inputTitle").style.borderColor = red;
                document.getElementById("inputTitle").scrollIntoView(true);
                document.getElementById("inputTitleVal").innerHTML =
                    "Organization Title is Required";
                return;
            }
            if (!this.orgName) {
                Toast.showToast("Organization Name is Required", "E");
                document.getElementById("inputOrgname").style.borderColor = red;
                document.getElementById("inputOrgname").scrollIntoView(true);
                document.getElementById("inputOrgnameVal").innerHTML =
                    "Organization Name is Required";
                return;
            }
            if (this.otherOrg === true) {
                Toast.showToast("Organization Does Not Exist", "E");
                document.getElementById("inputOrgname").style.borderColor = red;
                document.getElementById("inputOrgname").scrollIntoView(true);
                return;
            }
            if (this.orgValidity === false) {
                Toast.showToast(
                    "There is an issue with registration against this organization. Please contact FDX Support.",
                    "E"
                );
                document.getElementById("inputOrgname").scrollIntoView(true);
                document.getElementById("inputOrgname").style.borderColor = red;
                document.getElementById("inputOrgnameVal").innerHTML =
                    "There is an issue with registration against this organization. Please contact FDX Support.";
                return;
            }
            if (!this.email) {
                Toast.showToast("Business Email is Required", "E");
                document.getElementById("inputOrgemail").style.borderColor =
                    red;
                document.getElementById(
                    "inputOrgemailDomain"
                ).style.borderColor = red;
                document.getElementById("inputOrgemail").scrollIntoView(true);
                document.getElementById("inputOrgemailVal").innerHTML =
                    "Business Email is Required";
                this.emailStatus = "ERROR";
                return;
            }
            if (!this.password) {
                Toast.showToast("Password is Required", "E");
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "Password is Required";
                return;
            }
            if (this.passwordCheck() === false) {
                return;
            }
            if (!this.cpassword) {
                Toast.showToast("Confirm Password is Required", "E");
                document.getElementById("inputCpwd").style.borderColor = red;
                document.getElementById("inputCpwd").scrollIntoView(true);
                this.tempMsg = "Confirm Password is Required";
                document.getElementById("inputCpwdVal").innerHTML =
                    this.tempMsg;
                return;
            }
            if (this.password != this.cpassword) {
                Toast.showToast(
                    "Password and Confirm Password should be same",
                    "E"
                );
                document.getElementById("inputCpwd").style.borderColor = red;
                document.getElementById("inputCpwd").scrollIntoView(true);
                this.tempMsg = "Password and Confirm Password should be same";
                document.getElementById("inputCpwdVal").innerHTML =
                    this.tempMsg;
                return;
            }
            if (!this.reg.test(this.email)) {
                Toast.showToast("Please Enter Valid Email", "E");
                document.getElementById("inputOrgemail").style.borderColor =
                    "#FE3A31";
                document.getElementById(
                    "inputOrgemailDomain"
                ).style.borderColor = "#FE3A31";
                document.getElementById("inputOrgemail").scrollIntoView(true);
                this.emailverification();
                return;
            }
            // if (!this.emailVerified) {
            //     Toast.showToast("Please Verify Email", "E");
            //     document.getElementById("inputOrgemail").scrollIntoView(true);
            //     return;
            // }

            if (this.prefix === "(None)") {
                this.prefix = "";
            }
            if (this.suffix === "(None)") {
                this.suffix = "";
            }

            if (!this.emailVerified) {
                if (this.emailStatus !== 'VERIFY') {
                    Toast.showToast("Please Enter Valid Email", "E");
                    document.getElementById("inputOrgemail").scrollIntoView(true);
                    return;
                }
                this.sendEmail();
            } else {
                let request = {
                    membershipType: this.membershipType,
                    prefix: this.prefix,
                    firstName: this.fname,
                    middleName: this.mname,
                    lastName: this.lname,
                    suffix: this.suffix,
                    title: this.orgTitle.trim(),
                    email: this.email.trim(),
                    password: window.btoa(this.password),
                    organizationRequest: {
                        name: this.orgName,
                        imisId: JSON.parse(this.$store.state.user)
                            .organizationRequest.imisId,
                    },
                };
                this.loading = true;
                this.initiateCreateUserOrg(request);
            }
        },
        passwordCheck() {
            const red = "#FE3A31";
            if (!/^[a-zA-Z\d*&%$#@!)(]*$/.test(this.password)) {
                Toast.showToast(
                    "Password Can Only Contain Alphanumeric Characters, *,&,%,$,#,@ And !",
                    "E"
                );
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "Can Only Contain Alphanumeric Characters, *,&,%,$,#,@ And !";
                return false;
            }
            if (!/^[a-zA-Z\d*&%$#@!)(]{8,}$/.test(this.password)) {
                Toast.showToast(
                    "Minimum 8 Characters Is Required For Password",
                    "E"
                );
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "Minimum 8 Characters Is Required";
                return false;
            }
            if (!/^(?=.*\d)[a-zA-Z\d*&%$#@!)(]{8,}$/.test(this.password)) {
                Toast.showToast(
                    "At Least 1 Digit Is Required For Password",
                    "E"
                );
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "At Least 1 Digit Is Required";
                return false;
            }
            if (
                !/^(?=.*\d)(?=.*[a-z])[a-zA-Z\d*&%$#@!)(]{8,}$/.test(
                    this.password
                )
            ) {
                Toast.showToast(
                    "At Least 1 Lowercase Alphabet Is Required For Password",
                    "E"
                );
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "At Least 1 Lowercase Alphabet Is Required";
                return false;
            }
            if (
                !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d*&%$#@!)(]{8,}$/.test(
                    this.password
                )
            ) {
                Toast.showToast(
                    "At Least 1 Uppercase Alphabet Is Required For Password",
                    "E"
                );
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "At Least 1 Uppercase Alphabet Is Required";
                return false;
            }
            return true;
        },
        moreinfo() {
            document.getElementById("email_invalid").style.display = "block";
        },
        moreinfoOfac() {
            document.getElementById("ofac_invalid").style.display = "block";
        },
        isEmailValid() {
            if (this.userName && this.orgDomainName) {
                this.email = this.userName + "@" + this.orgDomainName;
                this.isEmailValidCheck();
            }
        },
        isEmailValidCheck() {
            if (this.email !== "" && !this.reg.test(this.email)) {
                this.emailStatus = "INVALID";
            }
            if (
                this.email !== "" &&
                this.reg.test(this.email) &&
                this.email !== this.sameEmail
            ) {
                let request = this.email.trim();
                this.emailStatus = "LOADING";
                this.checkEmailValid(request);
                this.sameEmail = this.email;
                this.emailValid = null;
                this.emailVerified = false;
            }
            if (this.emailVerified) {
                return null;
            }
            if (JSON.parse(this.$store.state.emailValid)) {
                this.emailValid = JSON.parse(this.$store.state.emailValid);
                this.sameEmail = this.email;
            }
            if (this.emailValid) {
                if (this.emailValid.status === true) {
                    this.emailStatus = "VERIFY";
                    document.getElementById("inputOrgemail").style.borderColor =
                        "#0e8bbc";
                    document.getElementById(
                        "inputOrgemailDomain"
                    ).style.borderColor = "#0e8bbc";
                    document.getElementById("invalid_email_msg").style.display =
                        "none";
                } else {
                    this.emailStatus = "INVALID";
                    if (this.emailValid.userExists === true) {
                        this.emailStatus = "ERROR";
                    }
                }
            }
        },
        emailverification() {
            document.getElementById("invalid_email_msg").style.display =
                "inline";
            document.getElementById("verify-email").style.display = "none";
        },
        sendEmail() {
            this.loading = true;
            let request = {
                membershipType: this.membershipType,
                prefix: this.prefix,
                firstName: this.fname,
                middleName: this.mname,
                lastName: this.lname,
                suffix: this.suffix,
                title: this.orgTitle.trim(),
                email: this.email,
                organizationRequest: {
                    name: this.orgName,
                    imisId: this.imisId,
                },
                password: window.btoa(this.password)
            };
            this.$gtag.event("sendEmail", {
                event_category: "general",
                event_label: "Email Sent For Verification",
                value: this.email.trim(),
            });
            this.initiateVerifyEmail(request);
        },
        respVerifyEmail() {
            this.loading = false;
            $("#myModal").modal("show");
        },
        closeTab() {
            window.open(
                "https://financialdataexchange.org/" + "FDX/FDX/Default.aspx?hkey=bd839735-ebf5-426a-91f9-8334cbae1438",
                "_self"
            );
        },
        abandonUser() {
            if (this.email) {
                this.getAbandonmentStatus(this.email);
                this.$gtag.event("abandonUser", {
                    event_category: "general",
                    event_label: "User abandon at sign up",
                    value: this.email.trim(),
                });
            } else {
                this.$gtag.event("abandonUser", {
                    event_category: "general",
                    event_label: "User abandon at sign up",
                    value: "Unknown",
                });
            }
            this.closeTab();
        },

        searchOrg() {
            if (this.orgName.length >= 3) {
                this.getOrganizationList(this.orgName);
                this.showOrgList = true;
                this.orgValidity = null;
            } else {
                this.showOrgList = false;
            }
        },
        selectedOrg(item) {
            this.orgName = item.name;
            this.imisId = item.imisId;
            if (
                item.membershipType === "SUS" ||
                item.membershipType === "STD"
            ) {
                this.membershipType = "FDX_MEMBER";
            } else {
                this.membershipType = "FDX_OBSERVER";
            }
            this.showOrgList = false;
            this.orgSelected = this.orgName;
            this.otherOrg = false;
            if (item.status !== "A") {
                this.orgValidity = false;
                Toast.showToast(
                    "There is an issue with registration against this organization. Please contact FDX Support.",
                    "E"
                );
                document.getElementById("inputOrgnameVal").innerHTML =
                    "There is an issue with registration against this organization. Please contact<a class='errormsg pl-3' style='color: #1fa785' href='" + "https://financialdataexchange.org/" + "FDX/Contact-Us.aspx' >FDX Support.</a >";
            } else {
                this.orgValidity = true;
                this.getDomainsByOrganization(item.imisId);
            }
        },
        checkOrgExists() {
            setTimeout(() => {
                this.showOrgList = false;
                if (this.orgSelected !== this.orgName) {
                    let exists = false;
                    for (let org of this.orgList) {
                        if (
                            org.name.trim().toLowerCase() ===
                            this.orgName.trim().toLowerCase()
                        ) {
                            exists = true;
                            this.orgValidity = null;
                            this.imisId = org.imisId;
                            if (org.status !== "A") {
                                this.orgValidity = false;
                                Toast.showToast(
                                    "There is an issue with registration against this organization. Please contact FDX Support.",
                                    "E"
                                );
                                document.getElementById(
                                    "inputOrgnameVal"
                                ).innerHTML =
                                    "There is an issue with registration against this organization. Please contact<a class='errormsg pl-3' style='color: #1fa785' href='" + "https://financialdataexchange.org/" + "FDX/Contact-Us.aspx' >FDX Support.</a >";
                            } else {
                                this.orgValidity = true;
                                this.getDomainsByOrganization(org.imisId);
                            }
                            break;
                        }
                    }
                    if (this.orgName.trim() === "") {
                        exists = true;
                        this.orgValidity = null;
                    }
                    this.otherOrg = !exists;
                }
                if (this.otherOrg === true || this.orgValidity === false) {
                    const red = "#FE3A31";
                    document.getElementById("inputOrgname").style.borderColor =
                        red;
                }
            }, 500);
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    padding: 10px;
}

a[disabled],
a[disabled]:hover {
    pointer-events: none;
    color: #e1e1e1;
}

.note {
    margin-left: 20px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #1978a0;
}

.container {
    box-sizing: border-box;
    max-width: 1123px;
    height: auto;
    left: 159px;
    top: 240px;
}

.page-head {
    color: #1978a0;
}

.heading {
    font-weight: 700;
    font-size: 29px;
    line-height: 34px;
    color: #1978a0;
}

.box {
    border: 1px solid #d8d8d8;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 20px;
}

#tab-menu h3 {
    color: white;
    background-color: #428bca;
    padding: 5px 15px;
}

.tab-content {
    border-style: solid;
    border-color: #ddd;
    border-width: 0 1px 1px 1px;
    padding: 10px;
    border-top: 3px solid #1978a0;
    /* height: 800px; */
}

.nav-tabs > li.active > a,
.nav-tabs > li.active > a:focus,
.nav-tabs > li.active > a:hover {
    background: #1978a0;
    width: 172px;
    height: 46px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
}

.nav-tabs > li > a {
    background: #f6f5f5;
    border: 1px solid #d8d8d8;
    width: 172px;
    height: 46px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #5a7d95;
    padding: 15px 15px;
    margin-right: 0px;
}

.col-form-label {
    text-align: left;
    margin-left: 20px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}

.form-control {
    background: #ffffff;
    border: 1px solid #0e8bbc;
    border-radius: 6px;
}

.form-control:focus {
    border: 1px solid #0e8bbc;
    box-shadow: 0px 0px 5px rgba(15, 109, 219, 0.3);
}

.form-control:active {
    border: 1px solid #0e8bbc;
    box-shadow: 0px 0px 5px rgba(15, 109, 219, 0.3);
}

.btn1 {
    background: #019382;
    border-radius: 6px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
    height: 45px;
}

.verifyli {
    font-size: 12px;
    line-height: 24px;
    float: left;
    color: #e26e25;
}

.errormsg {
    font-size: 12px;
    line-height: 24px;
    float: left;
    text-decoration-line: underline;
    color: #e26e25;
}

.nav.nav-tabs li:not(:first-of-type) a {
    pointer-events: none !important;
}

.modal-title {
    font-size: 20px;
    line-height: 22px;
    color: #1978a0;
}

.modal-body {
    font-size: 14px;
    line-height: 20px;
    color: #5a7d95;
    text-align: left;
}

.card {
    border-top: 2px solid #fe3a31 !important;
    background: #f6f5f5;
    margin-top: 20px;
    margin-right: 20px;
    text-align: left;
    color: #5a7d95;
    padding: 10px;
    line-height: 22px;
    border-style: none;
}

.hide_property {
    display: none;
}

.show_property {
    display: inline;
    float: left;
}

.required:after {
    content: " *";
    color: red;
}

.valMsg {
    color: red;
    font-size: 12px;
    line-height: 24px;
    float: left;
}

.light-blue {
    color: #0e8bbc;
}

.green {
    color: #1fa785;
}

.orange {
    color: #e26e25;
}

.dropdown-list {
    position: absolute !important;
    width: 100%;
    max-height: 500px;
    margin-top: 4px;
    overflow-y: auto;
    background: #ffffff;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
        0 4px 6px -2px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    z-index: 1000;
}
/deep/.dropdown-list {
    position: absolute !important;
}
.dropdown-item {
    display: flex;
    width: 100%;
    padding: 11px 16px;
    cursor: pointer;
}
.dropdown-item:hover {
    background: #edf2f7;
}
.dropdown-item-flag {
    max-width: 24px;
    max-height: 18px;
    margin: auto 12px auto 0px;
}

.apiLoader {
    width: 20px;
}

.col-sm-offset-8 {
    margin-left: 66.66666667% !important;
}
@media (max-width: 638px){
    #inputOrgemail,#inputOrgemailDomain {
        max-width: 38.666667%;
    }
    .business-email-col-2 {
        padding-left: 3% !important;
    }
}

@media(max-width:575px) {

    .col-sm-offset-8 {
        margin-left: 0% !important;
    }
    #inputOrgemail,#inputOrgemailDomain {
        max-width: 43.666667%;
    }
    .business-email-col-2 {
        max-width: 10.666667%;
        padding-left: 3% !important;
    }
}

</style>
